import { create } from 'zustand'
import type { IList } from '../../../interfaces'

type TOrigin = 'SEARCH' | 'PROPERTIES_TABLE' | 'PROPERTY_DETAIL'

export interface ModalAddListState {
  isLoading: boolean
  isLoadingAddOrDeletePropertyInList: {
    isLoading: boolean
    listId: string
  }
  isLoadingCreateNewList: boolean
  isLoadingGetLists: boolean
  lists: IList[] | null
  nameNewList: string
  reset: () => void
  searchValue: string | undefined
  setIsLoadingAddOrDeletePropertyInList: (isLoadingAddOrDeletePropertyInList: {
    isLoading: boolean
    listId: string
  }) => void
  pagination: {
    page: number
    pages: number
    total: number
  }
  setIsLoadingCreateNewList: (isLoadingCreateNewList: boolean) => void
  setIsLoadingGetLists: (isLoadingGetLists: boolean) => void
  setLists: (lists: IList[] | null) => void
  setNameNewList: (nameNewList: string) => void
  setSearchValue: (searchValue: string | undefined) => void
  setShowStepCreateNewList: (showStepCreateNewList: boolean) => void
  setPagination: (pagination: {
    page: number
    pages: number
    total: number
  }) => void
  showStepCreateNewList: boolean

  modalAddList: {
    isOpen: boolean
    multipleProperties?: boolean
    origin: TOrigin
    propertyId: string
    propertiesIds?: string[]
  }
  setModalAddList: (modalAddList: {
    isOpen: boolean
    multipleProperties?: boolean
    origin: TOrigin
    propertyId: string
    propertiesIds?: string[]
  }) => void
}

const initialState = {
  modalAddList: {
    isOpen: false,
    multipleProperties: false,
    propertyId: '',
    propertiesIds: [],
    origin: 'SEARCH' as TOrigin
  },
  isLoadingAddOrDeletePropertyInList: {
    isLoading: false,
    listId: ''
  },
  isLoadingCreateNewList: false,
  isLoadingGetLists: false,
  lists: null,
  listId: '',
  nameNewList: '',
  searchValue: undefined,
  showStepCreateNewList: false,
  pagination: {
    page: 1,
    pages: 1,
    total: 0
  }
}

export const useModalAddListStore = create<ModalAddListState>()((set, get) => ({
  ...initialState,
  isLoading:
    get()?.isLoadingGetLists ||
    get()?.isLoadingAddOrDeletePropertyInList?.isLoading ||
    get()?.isLoadingCreateNewList,
  reset: () => set({ ...initialState }),
  setIsLoadingAddOrDeletePropertyInList: (isLoadingAddOrDeletePropertyInList) =>
    set({ isLoadingAddOrDeletePropertyInList }),
  setIsLoadingCreateNewList: (isLoadingCreateNewList) =>
    set({ isLoadingCreateNewList }),
  setIsLoadingGetLists: (isLoadingGetLists) => set({ isLoadingGetLists }),
  setLists: (lists) => set({ lists }),
  setModalAddList: (modalAddList) => set({ modalAddList }),
  setNameNewList: (nameNewList) => set({ nameNewList }),
  setSearchValue: (searchValue) => set({ searchValue }),
  setShowStepCreateNewList: (showStepCreateNewList) =>
    set({ showStepCreateNewList }),
  setPagination: (pagination) => set({ pagination })
}))
